export default{
    namespaced: true,
    state:{
        url:null,
        development:false,
        gStatus:false
    },
    mutations:{
        setUrl(state,value){
            state.url = value;
        },
        setDevelopment(state,value){
            state.development = value;
        },
        setGStatus(state,value){
            state.gStatus = value;
        }
    },
    getters:{},
    setters:{}
}